/* ==========================================================================
   STICK'IT — SKIN « DIE-CUT STUDIO » : fiches produit (additif).
   Chargé après stickit.js et skin.js. Ne remplace ni n'appelle aucune fonction
   de stickit.js : il LIT l'état écrit par initPDP (.on, .pdp-price b, em,
   [data-preview-out], disabled) et ajoute du décor aria-hidden, des attributs
   data-sk-* et des variables CSS. Aucun texte n'est ajouté à la page (les
   libellés décoratifs passent par attr() en CSS). Doc : 11-skin-system.md
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var pdp = doc.querySelector('[data-pdp]');
  if (!pdp) return;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var data = {};
  try { data = JSON.parse($('#product-data').textContent); } catch (e) { data = {}; }
  var BASE = (window.StickitSkin && window.StickitSkin.base) || 'assets/skin/';
  var AR = [1.432, .78, 1.263, 1.508, 1.347, 1.254, 1.5, 1.41, 1.496, 1.504];
  function fmt(n) { return (Math.round(n * 100) / 100).toFixed(2); }
  function byOpt(name) { return $$('[data-opt]').filter(function (b) { return b.getAttribute('data-opt') === name; }); }

  /* glyphes One Number sans texte (aria-hidden par le conteneur) */
  function digits(str, into) {
    str.split('').forEach(function (c) {
      var n = doc.createElement('i');
      if (/\d/.test(c)) {
        n.className = 'sk-d';
        n.style.setProperty('--m', 'url("' + BASE + 'img-digits-' + c + '.svg")');
        n.style.setProperty('--ar', AR[+c]);
      } else { n.className = 'sk-ch'; n.setAttribute('data-c', c); }
      into.appendChild(n);
    });
  }

  /* 1. Prix en glyphes : miroir décoratif de .pdp-price b (réécrit par initPDP).
        Le <b> reste dans le DOM (lecteurs d'écran) ; le bouton reçoit le prix. */
  var priceBox = $('.pdp-price'), pb = $('.pdp-price b'), add = $('[data-add]');
  if (priceBox && pb) {
    var pp = doc.createElement('span');
    pp.className = 'sk-pp'; pp.setAttribute('aria-hidden', 'true');
    priceBox.insertBefore(pp, priceBox.firstChild);
    var last = '';
    var qIn = $('.qty input');
    // le bouton affiche le total : prix unitaire × quantité
    var btnPrice = function (t) {
      var q = qIn ? Math.max(1, parseInt(qIn.value, 10) || 1) : 1;
      if (q < 2) return t;
      return t.replace(/(\d+(?:[.,]\d+)?)/, function (n) { return (parseFloat(n.replace(',', '.')) * q).toFixed(2); });
    };
    var dock = $('[data-buybar-price]');   // barre d'achat fixe (mobile)
    var paint = function () {
      var t = (pb.textContent || '').trim();
      var tot = btnPrice(t);
      if (add) add.setAttribute('data-sk-price', tot);
      // la barre mobile affiche aussi le total (stickit.js y réécrit le prix unitaire à chaque option : on repasse après)
      if (dock && t && dock.textContent !== tot) dock.textContent = tot;
      if (t === last) return;
      var m = t.match(/(\d+)(?:[.,](\d+))?/);
      // « dès » (ou sa traduction) avant le premier chiffre → petit libellé devant les glyphes
      var from = m ? t.slice(0, m.index).trim() : '';
      if (from) pp.setAttribute('data-from', from); else pp.removeAttribute('data-from');
      pp.textContent = '';
      if (!m) { priceBox.classList.remove('sk-gp'); last = t; return; }
      digits(m[1], pp);
      if (m[2]) { var dd = doc.createElement('span'); dd.className = 'sk-pp-d'; digits(m[2], dd); pp.appendChild(dd); }
      priceBox.classList.add('sk-gp');
      if (last && !reduced) { pp.classList.remove('sk-tick'); void pp.offsetWidth; pp.classList.add('sk-tick'); }
      last = t;
    };
    new MutationObserver(paint).observe(pb, { childList: true, characterData: true, subtree: true });
    if (qIn) {
      qIn.addEventListener('input', paint); qIn.addEventListener('change', paint);
      $$('.qty [data-q]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(paint, 0); }); });
    }
    paint();
  }

  /* 2. Prix par option, lus dans #product-data : la cote affiche son prix,
        la finition premium affiche son surcoût. */
  (data.options || []).forEach(function (o) {
    if (!o.prices || !o.values) return;
    var vals = o.values.map(function (v) { return o.prices[v]; }).filter(function (p) { return p != null; });
    if (vals.length < 2) return;
    var min = Math.min.apply(null, vals), max = Math.max.apply(null, vals);
    if (min === max) return;
    var k = 1 - (data.discount || 0);
    byOpt(o.name).forEach(function (b) {
      var p = o.prices[b.getAttribute('data-val')];
      if (p == null) return;
      if (b.closest('.sizes')) b.setAttribute('data-sk-price', fmt(p * k));
      else if (p > min) b.setAttribute('data-sk-plus', '+' + String(+((p - min) * k).toFixed(2)));
    });
  });
  // suppléments additifs (couleurs spéciales, noir mat Obsaners…) : affichés tels quels, non remisés
  (data.options || []).forEach(function (o) {
    if (!o.surcharge) return;
    byOpt(o.name).forEach(function (b) { var s = o.surcharge[b.getAttribute('data-val')]; if (s) b.setAttribute('data-sk-plus', '+' + String(+(+s).toFixed(2))); });
  });
  $$('.sizes').forEach(function (s) {
    var bs = $$('button', s);
    var size = bs.length && bs.every(function (b) { return /^\d+(\.\d+)?\s*cm$/i.test(b.getAttribute('data-val') || ''); });
    s.setAttribute('data-sk-kind', size ? 'size' : 'list');
  });

  /* 3. Typographies (Instagram) : chaque bouton dans sa police, l'aperçu aussi. */
  var prev = $('.cust-preview');
  var typo = (data.options || []).filter(function (o) { return /typo/i.test(o.name); })[0];
  if (typo) {
    var fam = typo.values.map(function (v) { return 'family=' + v.replace(/ /g, '+'); }).join('&');
    var l = doc.createElement('link'); l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?' + fam + '&display=swap';
    doc.head.appendChild(l);
    byOpt(typo.name).forEach(function (b) { b.style.fontFamily = "'" + b.getAttribute('data-val') + "',var(--sk-f)"; });
  }
  var LOGO = {
    Instagram: '<rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="#000" stroke-width="2.4"/><circle cx="12" cy="12" r="4.2" fill="none" stroke="#000" stroke-width="2.4"/><circle cx="17.4" cy="6.6" r="1.4"/>',
    TikTok: '<path d="M14 3h3a4.5 4.5 0 0 0 4 4v3a7.5 7.5 0 0 1-4-1.2V15a6 6 0 1 1-6-6v3.2a2.8 2.8 0 1 0 3 2.8z"/>',
    Whatsapp: '<path d="M12 2.5a9.5 9.5 0 0 0-8.2 14.3L2.5 21.5l4.8-1.3A9.5 9.5 0 1 0 12 2.5zm0 2.6a6.9 6.9 0 1 1-3.6 12.8l-.3-.2-2 .6.6-1.9-.2-.3A6.9 6.9 0 0 1 12 5.1z"/>',
    Facebook: '<path d="M14 8h3V4.2h-3.2C10.6 4.2 9.6 6.3 9.6 9v2H7v3.8h2.6V22h4v-7.2h3l.5-3.8H13.6V9.4c0-.9.3-1.4 1.4-1.4z"/>',
    Youtube: '<path d="M21.6 7.2a2.6 2.6 0 0 0-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4A2.6 2.6 0 0 0 2.4 7.2 27 27 0 0 0 2 12a27 27 0 0 0 .4 4.8 2.6 2.6 0 0 0 1.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4a2.6 2.6 0 0 0 1.8-1.8A27 27 0 0 0 22 12a27 27 0 0 0-.4-4.8zM10 15V9l5.2 3z"/>'
  };

  /* 4. État des options -> décor : matière/police/logo de l'aperçu, fond de
        la planche (« couleur de fond »), mot collé qui saute à chaque choix. */
  function sync(clicked) {
    $$('.opt').forEach(function (opt) {
      var on = $('[data-opt].on', opt);
      var em = $('.lab em', opt);
      if (em && em.textContent) opt.classList.remove('sk-need');
      if (!on) return;
      var name = on.getAttribute('data-opt'), val = on.getAttribute('data-val');
      // (Akrapovic : la « couleur de fond » change la plaque du sticker, pas le fond de la galerie — voir §12)
      if (/fond/i.test(name) && on.getAttribute('data-color') && !/akrapovic/.test(data.handle || '')) $('.gal-main') && $('.gal-main').style.setProperty('--sk-plate', on.getAttribute('data-color'));
      if (prev && typo && name === typo.name) { prev.setAttribute('data-sk-font', val); prev.style.setProperty('--sk-font', "'" + val + "'"); }
      if (prev && /logo/i.test(name)) {
        prev.setAttribute('data-sk-logo', val);
        if (LOGO[val]) prev.style.setProperty('--sk-logo', 'url("data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' + LOGO[val] + '</svg>') + '")');
      }
    });
    if (clicked) {
      var o = clicked.closest('.opt');
      if (o && !reduced) { o.classList.remove('sk-pop'); void o.offsetWidth; o.classList.add('sk-pop'); }
      if (prev && clicked.getAttribute('data-ckind') && !/fond/i.test(clicked.getAttribute('data-opt'))) prev.setAttribute('data-sk-ckind', clicked.getAttribute('data-ckind'));
    }
  }
  pdp.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-opt]');
    if (b) setTimeout(function () { sync(b); }, 0);
  });
  sync(null);

  /* 5. Bouton désactivé (pointer-events:none dans stickit.css) : le clic tombe
        sur le conteneur -> on montre les options qui manquent. */
  function needs() {
    var miss = $$('.opt').filter(function (o) { var em = $('.lab em', o); return em && !em.textContent; });
    miss.forEach(function (o) { o.classList.remove('sk-need'); void o.offsetWidth; o.classList.add('sk-need'); });
    if (miss[0]) miss[0].scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  }
  $$('.pdp-cta, .buybar').forEach(function (box) {
    box.addEventListener('click', function (ev) {
      var btn = $('[data-add], [data-add-mobile]', box);
      if (btn && btn.disabled && !ev.target.closest('a')) needs();
    });
  });

  /* 6. Galerie : compteur, loupe qui suit le pointeur, balayage tactile. */
  var gm = $('.gal-main'), mains = $$('.gal-main img'), thumbs = $$('.gal-thumbs button');
  if (gm && mains.length) {
    var n = doc.createElement('span'); n.className = 'sk-gal-n'; n.setAttribute('aria-hidden', 'true');
    gm.appendChild(n);
    var idx = function () { for (var i = 0; i < mains.length; i++) if (mains[i].classList.contains('on')) return i; return 0; };
    var pad = function (v) { return (v < 10 ? '0' : '') + v; };
    var count = function () { n.setAttribute('data-n', pad(idx() + 1) + ' / ' + pad(mains.length)); };
    new MutationObserver(count).observe(gm, { attributes: true, attributeFilter: ['class'], subtree: true });
    count();
    if (fine && !reduced) {
      gm.addEventListener('pointermove', function (ev) {
        var r = gm.getBoundingClientRect();
        gm.style.setProperty('--zx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        gm.style.setProperty('--zy', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        gm.classList.add('sk-zoom');
      });
      gm.addEventListener('pointerleave', function () { gm.classList.remove('sk-zoom'); });
    }
    if (thumbs.length > 1) {
      var x0 = null, y0 = 0;
      gm.addEventListener('touchstart', function (ev) { x0 = ev.touches[0].clientX; y0 = ev.touches[0].clientY; }, { passive: true });
      gm.addEventListener('touchend', function (ev) {
        if (x0 == null) return;
        var dx = ev.changedTouches[0].clientX - x0, dy = ev.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        var t = thumbs[(idx() + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length];
        t.click();
        t.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
      }, { passive: true });
    }
  }

  /* 7. Dock mobile : vignette du produit. */
  var bar = $('.buybar'), th = $('.gal-thumbs img') || $('.gal-main img');
  if (bar && th) bar.style.setProperty('--sk-thumb', 'url("' + th.getAttribute('src') + '")');

  /* 9. Couleurs sombres (noir, noir mat…) : jamais noir sur noir.
        a) aperçu de personnalisation : fond clair dès que l'encre choisie est sombre ;
        b) galerie : un visuel détouré sombre (logo noir sur fond transparent) reçoit un fond clair. */
  function lum(rgb) { var m = (rgb || '').match(/\d+(\.\d+)?/g); if (!m) return 1; return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255; }
  if (prev) {
    var ink = function () {
      var c = prev.style.getPropertyValue('--preview-color').trim(), h = c.match(/^#?([0-9a-f]{6})$/i);
      var l = h ? lum(parseInt(h[1].slice(0, 2), 16) + ',' + parseInt(h[1].slice(2, 4), 16) + ',' + parseInt(h[1].slice(4), 16)) : lum(getComputedStyle($('[data-preview-out]', prev) || prev).color);
      prev.classList.toggle('sk-ink-dark', l < 0.22);
    };
    new MutationObserver(ink).observe(prev, { attributes: true, attributeFilter: ['style', 'class'] });
    pdp.addEventListener('click', function () { setTimeout(ink, 30); });
    ink();
  }
  // analyse sur la miniature (180 px) quand elle existe : sinon chaque grande photo de la galerie serait téléchargée d'office
  function darkArt(img, mark, small) {
    var src = (small && (small.currentSrc || small.getAttribute('src'))) || img.currentSrc || img.src || '';
    if (src.indexOf('//') === 0) src = location.protocol + src;   // toujours absolu (images locales depuis 2026-10)
    if (!/^https?:/.test(src)) return;
    var t = new Image(); t.crossOrigin = 'anonymous';
    t.onload = function () {
      try {
        var c = doc.createElement('canvas'); c.width = c.height = 48;
        var x = c.getContext('2d'); x.drawImage(t, 0, 0, 48, 48);
        var d = x.getImageData(0, 0, 48, 48).data, op = 0, tr = 0, L = 0;
        for (var i = 0; i < d.length; i += 4) {
          if (d[i + 3] < 40) { tr++; continue; }
          op++; L += (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255;
        }
        if (tr > d.length / 4 * 0.15 && op && L / op < 0.3) mark.forEach(function (m) { m.classList.add('sk-dark-art'); });
      } catch (e) {}
    };
    t.src = src.replace(/\/v1\/(fit|fill)\/w_\d+,h_\d+/, '/v1/$1/w_96,h_96');
  }
  mains.forEach(function (img, i) { darkArt(img, [img].concat(thumbs[i] ? [thumbs[i]] : []), thumbs[i] && thumbs[i].querySelector('img')); });

  /* 11. Covers casque : l'aperçu du texte utilise la police du modèle
         (mêmes polices que l'outil casque : NecroSarqe, Novocane, TrashCrush ; Earthen Parasite pour Scream). */
  var HELMET_FONT = { 'style-death-metal': 'NecroSarqe', 'style-novocare': 'Novocane', 'trash-crush': 'TrashCrush', 'earthen-parasite-obsaners-edition': 'EarthenParasite' };
  if (prev) Object.keys(HELMET_FONT).forEach(function (k) {
    if (location.pathname.indexOf('/products/stickers-casque-' + k) < 0) return;
    prev.setAttribute('data-sk-font', HELMET_FONT[k]);
    prev.style.setProperty('--sk-font', "'" + HELMET_FONT[k] + "'");
    prev.classList.add('sk-helmet-font');
  });

  /* 10. Logo réseau social : même hauteur que le texte, comme sur les photos d'exemple
         (du haut des majuscules au bas des jambages, p. ex. « g »), quelle que soit la police. */
  var pOut = prev && $('[data-preview-out]', prev);
  if (pOut) {
    var cv = doc.createElement('canvas').getContext('2d');
    var fitLogo = function () {
      var withLogo = prev.hasAttribute('data-sk-logo');
      if (withLogo) pOut.style.fontSize = '';             // taille de base de la feuille de style, recalculée à chaque fois
      var cs = getComputedStyle(pOut), size = parseFloat(cs.fontSize) || 40;
      cv.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + size + 'px ' + cs.fontFamily;
      var up = cs.textTransform === 'uppercase';
      // comme sur les photos d'exemple : logo centré sur la hauteur des majuscules,
      // ~1,75 × cette hauteur si le texte a des jambages (g, j, p, q, y), ~1,3 × en capitales
      var cap = cv.measureText('H').actualBoundingBoxAscent || size * 0.72;
      if (withLogo) {
        // même hauteur de majuscules (donc même logo) quelle que soit la typographie : chaque police a la sienne
        // à taille égale (Black Ops One 34 px, Anton 45 px pour 52 px). Puis le tout tient sur une ligne dans le cadre.
        var fs = size * (size * 0.72) / cap;
        pOut.style.fontSize = fs.toFixed(1) + 'px';
        var pc = getComputedStyle(prev), room = prev.clientWidth - parseFloat(pc.paddingLeft) - parseFloat(pc.paddingRight) - 8;
        var w = pOut.getBoundingClientRect().width;
        if (room > 0 && w > room) { fs *= room / w; pOut.style.fontSize = fs.toFixed(1) + 'px'; }
        cap = cap * fs / size;
      }
      var txt = pOut.textContent || '';
      var k = ((!up && /[gjpqy]/.test(txt)) ? 1.75 : 1.3) * 1.35;   // logo agrandi (demande 2026-10) : plus lisible à côté du pseudo
      var logo = prev.getAttribute('data-sk-logo') || '';
      if (/tiktok/i.test(logo)) k *= 1.12;                  // pictogramme étroit : un peu plus grand pour le même poids visuel
      var h = cap * k;
      var hv = h.toFixed(1) + 'px', dv = ((h - cap) / 2).toFixed(1) + 'px';
      if (prev.style.getPropertyValue('--sk-logo-h') !== hv) prev.style.setProperty('--sk-logo-h', hv);
      if (prev.style.getPropertyValue('--sk-logo-dy') !== dv) prev.style.setProperty('--sk-logo-dy', dv);
    };
    var fitSoon = function () { requestAnimationFrame(fitLogo); if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fitLogo); };
    new MutationObserver(fitSoon).observe(prev, { attributes: true, attributeFilter: ['style', 'data-sk-font', 'data-sk-logo', 'class'] });
    new MutationObserver(fitSoon).observe(pOut, { childList: true, characterData: true, subtree: true });
    addEventListener('resize', fitSoon);
    fitSoon();
  }

  /* 12. La présentation suit la couleur choisie : chaque couleur affiche son visuel
         (index des images de la galerie, relevés visuellement sur chaque fiche). */
  var COLOR_IMG = {
    'stickers-aprilia-rs660': { 'blanc': 0, 'noir': 2, 'rouge': 3, 'jaune': 4, 'orange': 5, 'violet': 6, 'rose': 7, 'vert': 8, 'bleu clair': 9, 'bleu foncé': 10, 'rose fuchsia': 11, 'bordeaux': 12, 'gris': 13, 'gris nardo': 14, 'rouge sang': 15, 'beige': 16, 'brun': 17, 'noir mat': 18, 'gris métallisé': 19, 'gris anthracite': 20, 'doré': 21 },
    'sticker-aprilia-style-hamilton': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'jaune': 3, 'violet': 4, 'rose': 5, 'vert': 6, 'bleu clair': 7, 'bleu foncé': 8, 'rose fuchsia': 9, 'bordeaux': 10, 'gris': 11, 'gris nardo': 12, 'rouge sang': 13, 'beige': 14, 'brun': 15, 'noir mat': 16, 'réfléchissant': 17, 'gris métallisé': 18, 'gris anthracite': 19, 'doré': 20 },
    'etoile-gothique-obsaners-edition': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'réfléchissante': 3, 'noir mat': 1 },
    'croix-trash-obsaners-edition': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'réfléchissante': 3, 'noir mat': 1 },
    'stickers-complets-logo-agv': { 'blanc': 1, 'noir': 2, 'rouge': 3, 'jaune': 4, 'orange': 5, 'violet': 6, 'rose': 7, 'vert': 8, 'bleu clair': 9, 'bleu foncé': 10, 'rose fuchsia': 11, 'bordeaux': 12, 'gris': 13, 'gris nardo': 14, 'rouge sang': 15, 'beige': 16, 'brun': 17, 'noir mat': 18, 'réfléchissant': 19, 'gris métallisé': 20, 'gris anthracite': 21, 'holographique': 22, 'doré': 23 },
    'stickers-cover-italie-agv': { 'blanc': 1, 'noir': 2, 'rouge': 3, 'jaune': 4, 'orange': 5, 'violet': 6, 'rose': 7, 'vert': 8, 'bleu clair': 9, 'bleu foncé': 10, 'rose fuchsia': 11, 'bordeaux': 12, 'gris': 13, 'gris nardo': 14, 'rouge sang': 15, 'beige': 16, 'brun': 17, 'noir mat': 18, 'réfléchissant': 19, 'gris métallisé': 20, 'gris anthracite': 21, 'holographique': 22, 'doré': 23 },
    'stickers-casque-unique-no-fear': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'jaune': 3, 'orange': 4, 'violet': 5, 'rose': 6, 'vert': 7, 'bleu clair': 8, 'bleu foncé': 9, 'rose fuchsia': 10, 'bordeaux': 11, 'gris': 12, 'gris nardo': 13, 'rouge sang': 14, 'beige': 15, 'brun': 16, 'noir mat': 17, 'réfléchissant': 18, 'gris métallisé': 19, 'gris anthracite': 20, 'holographique': 21, 'doré': 22 },
    'come-get-me-obsaners-edition': { 'rouge': 0, 'blanc': 1, 'noir': 2, 'noir mat': 3 },
    'stickers-stick-it': { 'blanc': 0, 'noir': 1, 'noir mat': 1, 'réfléchissant': 2 },
    'stickers-casque-earthen-parasite-obsaners-edition': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'réfléchissante': 3, 'noir mat': 1 },
    'stickers-casque-style-death-metal': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'jaune': 3, 'orange': 4, 'violet': 5, 'rose': 6, 'vert': 7, 'bleu clair': 8, 'bleu foncé': 9, 'rose fuchsia': 10, 'bordeaux': 11, 'gris': 12, 'gris nardo': 13, 'rouge sang': 14, 'beige': 15, 'brun': 16, 'noir mat': 17, 'réfléchissant': 18, 'gris métallisé': 19, 'gris anthracite': 20, 'holographique': 21, 'doré': 22 },
    'stickers-casque-style-novocare': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'jaune': 3, 'orange': 4, 'violet': 5, 'rose': 6, 'vert': 7, 'bleu clair': 8, 'bleu foncé': 9, 'rose fuchsia': 10, 'bordeaux': 11, 'gris': 12, 'gris nardo': 13, 'rouge sang': 14, 'beige': 15, 'brun': 16, 'noir mat': 17, 'réfléchissant': 18, 'gris métallisé': 19, 'gris anthracite': 20, 'holographique': 21, 'doré': 22 },
    'stickers-casque-trash-crush': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'jaune': 3, 'orange': 4, 'violet': 5, 'rose': 6, 'vert': 7, 'bleu clair': 8, 'bleu foncé': 9, 'rose fuchsia': 10, 'bordeaux': 11, 'gris': 12, 'gris nardo': 13, 'rouge sang': 14, 'beige': 15, 'brun': 16, 'noir mat': 17, 'réfléchissant': 18, 'gris métallisé': 19, 'gris anthracite': 20, 'holographique': 21, 'doré': 22 },
    'stickers-cover-complets-logo-nolan': { 'blanc': 1, 'noir': 2, 'rouge': 3, 'jaune': 4, 'orange': 5, 'violet': 6, 'rose': 7, 'vert': 8, 'bleu clair': 9, 'bleu foncé': 10, 'rose fuchsia': 11, 'bordeaux': 12, 'gris': 13, 'brun': 14, 'réfléchissant': 15, 'gris métallisé': 16, 'holographique': 17, 'doré': 18 },
    'stickers-coque-quad-lock-ou-sp-connect': { 'blanc': 2, 'noir': 3, 'rouge': 4, 'jaune': 5, 'orange': 6, 'violet': 7, 'rose': 8, 'vert': 9, 'bleu clair': 10, 'bleu foncé': 11, 'rose fuchsia': 12, 'bordeaux': 13, 'gris': 14, 'gris nardo': 15, 'rouge sang': 16, 'beige': 17, 'brun': 18, 'noir mat': 19, 'réfléchissant': 20, 'gris métallisé': 21, 'gris anthracite': 22, 'holographique': 23, 'doré': 24 },
    'instagram-stickers': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'jaune': 3, 'orange': 4, 'violet': 5, 'rose': 6, 'vert': 7, 'bleu clair': 8, 'bleu foncé': 9, 'rose fuchsia': 10, 'bordeaux': 11, 'gris': 12, 'gris nardo': 13, 'rouge sang': 14, 'beige': 15, 'brun': 16, 'noir mat': 17, 'réfléchissant': 18, 'gris métallisé': 19, 'gris anthracite': 20, 'holographique': 21, 'doré': 22 },
    'one-number-one-identity-numero-de-course': { 'blanc': 0, 'noir': 1, 'rouge': 2, 'jaune': 3, 'orange': 4, 'violet': 5, 'rose': 6, 'vert': 7, 'bleu clair': 8, 'bleu foncé': 9, 'rose fuchsia': 10, 'bordeaux': 11, 'gris': 12, 'gris nardo': 13, 'rouge sang': 14, 'beige': 15, 'brun': 16, 'noir mat': 17, 'réfléchissant': 18, 'gris métallisé': 19, 'gris anthracite': 20, 'holographique': 21, 'doré': 22 }
  };
  // couleur sans photo : on revient à la 1re image de la fiche plutôt que de laisser la photo d'une autre couleur
  // (Akrapovic a son propre visuel par couleur, voir juste en dessous)
  var cmap = /^stickers-akrapovic-/.test(data.handle || '') ? null : (COLOR_IMG[data.handle] || {});
  if (cmap && thumbs.length) {
    pdp.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-opt]');
      if (!b || /fond/i.test(b.getAttribute('data-opt')) || !b.closest('.swatches')) return;
      var k = cmap[(b.getAttribute('data-val') || '').trim().toLowerCase()];
      if (k == null || !thumbs[k]) k = 0;
      if (!thumbs[k].classList.contains('on')) thumbs[k].click();
    });
  }
  // Akrapovic : la photo n° 1 montre le logo dans la couleur ET la plaque choisies (un visuel par couleur
  // de la palette, plaque noire ou blanche) ; « couleur de fond » Blanc passe aussi les autres photos en plaque blanche.
  if (/^stickers-akrapovic-(long|custom)$/.test(data.handle || '') && mains.length) {
    var tImgs = thumbs.map(function (t) { return $('img', t); });
    var orig = mains.map(function (m) { return m.getAttribute('src'); }), origT = tImgs.map(function (i) { return i && i.getAttribute('src'); });
    var akra = { col: null, white: false };
    var slug = function (s) { return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '-'); };
    // version des visuels : \u00e0 incr\u00e9menter quand on les r\u00e9g\u00e9n\u00e8re (sinon navigateur et CDN servent l'ancienne copie)
    var AKRA_V = '?v=2';
    var paintAkra = function () {
      mains.forEach(function (m, i) { m.src = akra.white ? BASE + 'img-akra-' + data.handle + '-' + i + '-w.webp' + AKRA_V : orig[i]; });
      tImgs.forEach(function (t, i) { if (t) t.src = akra.white ? BASE + 'img-akra-' + data.handle + '-' + i + '-w.webp' + AKRA_V : origT[i]; });
      if (!akra.col) return;
      var src = BASE + 'img-akra-' + data.handle + '-c-' + slug(akra.col) + '-' + (akra.white ? 'blanc' : 'noir') + '.webp' + AKRA_V;
      mains[0].src = src; if (tImgs[0]) tImgs[0].src = src;
      if (thumbs[0] && !thumbs[0].classList.contains('on')) thumbs[0].click();
    };
    pdp.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-opt]');
      if (!b) return;
      if (/fond/i.test(b.getAttribute('data-opt'))) akra.white = /blanc/i.test(b.getAttribute('data-val') || '');
      else if (b.closest('.swatches')) akra.col = b.getAttribute('data-val');
      else return;
      paintAkra();
    });
  }

  /* 13. Étoile / Croix (Obsaners) : alerte sous 8 cm — les pointes fines adhèrent moins bien. */
  if (/^(etoile-gothique|croix-trash)-obsaners-edition$/.test(data.handle || '')) {
    var sizes = $('.sizes'), warn = doc.createElement('p');
    warn.className = 'sk-size-warn'; warn.setAttribute('role', 'status'); warn.hidden = true;
    warn.textContent = 'Attention : sous 8 cm, les pointes fines du motif ont peu de surface et peuvent moins bien adhérer. Pour une tenue optimale, choisis 8 cm ou plus.';
    if (sizes) sizes.parentNode.insertBefore(warn, sizes.nextSibling);
    pdp.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('.sizes [data-opt]');
      if (!b) return;
      var cm = parseFloat(b.getAttribute('data-val'));
      warn.hidden = !(cm < 8);
    });
  }

  /* 14. Numéro de course : uniquement des chiffres dans le champ de prévisualisation. */
  if (doc.body.classList.contains('sk-one')) {
    var numIn = $('[data-preview]');
    if (numIn) {
      numIn.setAttribute('inputmode', 'numeric'); numIn.setAttribute('pattern', '[0-9]*'); numIn.setAttribute('placeholder', 'Ex. 93');
      numIn.addEventListener('beforeinput', function (ev) { if (ev.data && /\D/.test(ev.data)) ev.preventDefault(); });
      numIn.addEventListener('input', function () {
        var clean = numIn.value.replace(/\D/g, '');
        if (clean !== numIn.value) { numIn.value = clean; numIn.dispatchEvent(new Event('input', { bubbles: true })); }
      });
    }
  }

  /* 8. ONE NUMBER : le numéro tapé s'affiche en glyphes de course. */
  var out = $('[data-preview-out]');
  if (doc.body.classList.contains('sk-one') && prev && out) {
    var num = doc.createElement('span'); num.className = 'sk-num'; num.setAttribute('aria-hidden', 'true');
    prev.appendChild(num);
    // approche par paire (en fraction de hauteur) : glyphes penchés → un chevauchement fixe collait
    // certains chiffres (x7, 44, 2x…) et en écartait d'autres. Valeurs mesurées sur l'encre des SVG
    // pour un vide constant de ~7 % de la hauteur entre deux chiffres.
    var KERN = [[-0.214,-0.147,-0.244,-0.234,-0.187,-0.221,-0.217,-0.068,-0.23,-0.251],[-0.237,-0.174,-0.27,-0.254,-0.207,-0.244,-0.237,-0.094,-0.25,-0.264],[-0.16,-0.128,-0.204,-0.171,-0.133,-0.168,-0.157,-0.048,-0.168,-0.187],[-0.214,-0.148,-0.244,-0.24,-0.194,-0.227,-0.224,-0.071,-0.237,-0.257],[-0.058,-0.114,-0.128,-0.104,-0.029,-0.08,-0.084,-0.114,-0.088,-0.141],[-0.144,-0.194,-0.191,-0.157,-0.114,-0.154,-0.141,-0.131,-0.154,-0.174],[-0.207,-0.217,-0.261,-0.234,-0.181,-0.214,-0.22,-0.127,-0.23,-0.254],[-0.257,-0.204,-0.294,-0.307,-0.42,-0.261,-0.347,-0.127,-0.324,-0.337],[-0.211,-0.144,-0.244,-0.247,-0.197,-0.224,-0.237,-0.068,-0.247,-0.27],[-0.207,-0.144,-0.24,-0.251,-0.214,-0.221,-0.264,-0.068,-0.27,-0.28]];
    var draw = function () {
      var inp = $('[data-preview]'), t = inp ? inp.value.trim() : '';
      num.textContent = '';
      var on = /\d/.test(t);
      if (on) {
        digits(t, num);
        for (var i = 1; i < t.length; i++) {
          if (/\d/.test(t[i - 1]) && /\d/.test(t[i]) && num.children[i])
            num.children[i].style.marginLeft = 'calc(var(--dh) * ' + (KERN[+t[i - 1]][+t[i]] + 0.04).toFixed(3) + ')';   // +0,04 : vide porté à ~11 %
        }
      }
      prev.classList.toggle('sk-glyphing', on);
    };
    new MutationObserver(draw).observe(out, { childList: true, characterData: true, subtree: true });
    draw();
  }
})();

/* Galerie : seule la photo affichée est téléchargée au chargement ; les autres suivent une fois la page chargée,
   ou dès qu'on les affiche (classe .on posée par la galerie / le choix de couleur). CSS : pdp.css, sk-ld. */
(function () {
  var main = document.querySelector('body.sk-pdp .gal-main');
  if (!main) return;
  var ld = function (i) { if (!i.classList.contains('sk-ld')) i.classList.add('sk-ld'); };
  new MutationObserver(function (ms) {
    ms.forEach(function (m) { if (m.target.tagName === 'IMG' && m.target.classList.contains('on')) ld(m.target); });
  }).observe(main, { subtree: true, attributes: true, attributeFilter: ['class'] });
  var all = function () { Array.prototype.forEach.call(main.querySelectorAll('img'), ld); };
  var later = function () { setTimeout(function () { (window.requestIdleCallback || setTimeout)(all); }, 1200); };
  if (document.readyState === 'complete') later(); else addEventListener('load', later);
})();
